import React from 'react';
import { Step, StepName } from '|/app/services';
import styles from './task-tile-list.module.css';
import TaskTile from '../task-tile';

interface TaskTileListProps {
  steps: Step[];
  onOpenStep: (step: Step) => void;
  partialCompletionText: string | null;
  onTileShown?: (stepId: StepName) => void;
}

const TaskTileList: React.FC<TaskTileListProps> = ({
  steps,
  onOpenStep,
  partialCompletionText,
  onTileShown
}) => {
  const firstIncompleteId = steps.find(s => !s.isComplete)?.id ?? null;

  const showIvMessage = steps.some(s => s.id === StepName.IdentityVerification && !s.isComplete);

  return (
    <div className={styles.list}>
      {steps.map(step => {
        let status: 'complete' | 'in-progress' | 'not-started';
        if (step.isComplete) {
          status = 'complete';
        } else if (partialCompletionText !== null && step.id === firstIncompleteId) {
          status = 'in-progress';
        } else {
          status = 'not-started';
        }

        return (
          <TaskTile
            key={step.id}
            step={step}
            status={status}
            partialCompletionText={step.id === firstIncompleteId ? partialCompletionText : null}
            onOpen={() => {
              onOpenStep(step);
            }}
            onShown={onTileShown}
          />
        );
      })}
      {showIvMessage && (
        <p className={styles.ivMessage}>
          We&apos;ll do a quick check for any additional tasks after completing identity
          verification.
        </p>
      )}
    </div>
  );
};

export default TaskTileList;
